import api from './api';
import { MenuBySourceResponse } from '../types/menu.types';

export const menuService = {
  async getMenuBySource(sourceCode: string, promoCode?: string): Promise<MenuBySourceResponse> {
    const params = new URLSearchParams({ source_code: sourceCode });
    if (promoCode) {
      params.append('promo_code', promoCode);
    }
    const response = await api.get<MenuBySourceResponse>(`/dishes/menu/by-source?${params.toString()}`);
    return response.data;
  },
};
